import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-automation-screen',
  templateUrl: './automation-screen.component.html',
  styleUrls: ['./automation-screen.component.scss']
})
export class AutomationScreenComponent implements OnInit {
    frontend_url: string;
    params: { key: string, value: string }[];
  
    constructor(
      public dialogRef: MatDialogRef<AutomationScreenComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private dialog: MatDialog
    ) {
      this.params = this.data.params;
      
      const url = new URL(this.data.frontend_url);
      url.searchParams.append('hide_nav', 'true');
      for (const item of this.params) {
        url.searchParams.append(item.key, item.value);
      }
      this.frontend_url = url.toString();
    }
  
    ngOnInit() {
    }
  
    async close() {
      const confirmDialog = this.dialog.open(ConfirmModalComponent, {
        data: {
          message: 'Do you wish to close the optimization process? You will lost all the process and have to start over again.'
        }
      });
  
      const resp = await confirmDialog.afterClosed().toPromise();
      if (resp) {
        this.dialogRef.close(true);
      }
    }
}
